import { createGlobalStyle } from 'styled-components'

const StyledGlobal = createGlobalStyle`
  * {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  html,body {
      width: 100%;
      height: 100%;
      margin: 0px;
      padding: 0px;
      overflow-x: hidden; 
      scroll-behavior: smooth;
      font-family: sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 18px;
      letter-spacing: .23px;
      line-height: 1.3em;
      color: #5a5a65;
  }

  p, span {
    color: #5a5a65;
  }

  ol, ul, li {
    list-style: none;
  }

  div {
    display: block;
  }

  @media only screen and (min-device-width: 768px) {
    body {


    }

    body::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3, 0);
        background-color: #FFf;
    }

    body::-webkit-scrollbar{
        width: 15px;
        background-color: #fff;
    }

    body::-webkit-scrollbar-thumb{
        background-color: #582C83;
        background-image: -webkit-gradient(linear,
									   left bottom,
									   left top,
									   color-stop(0.44, #582C83),
									   color-stop(0.80, #582C83));
    }

  }
    

`

export default StyledGlobal;